import Header from "./Header"
import Main from "./Main"
import Footer from "./Footer"
import "./css/styles.css"

function App() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
